import { SettingsInterface } from '../SettingsInterface';
import { ModelInterface } from '../ModelInterface';

const invoiceModel: ModelInterface = {
  "template": "default",
  "name": "models.invoice.sales",
  "type": "invoice",
  "columns": [
    "index",
    "description",
    "quantity",
    "unit",
    "unitPrice",
    "vatPct",
    "total"
  ],
  // @ts-ignore
  "paymentMethods": [],
  "fields": [
    {
      "name": "sender",
      "default": "59fb165b59149705003ab679",
      "visible": true
    },
    {
      "name": "language",
      "default": "en",
      "visible": true
    },
    {
      "name": "currency",
      "default": "EUR",
      "visible": true
    },
    {
      "name": "title",
      "default": "INVOICE",
      "visible": true
    },
    {
      "name": "type",
      "default": "2",
      "visible": true
    },
    {
      "name": "paymentTime",
      "default": "14",
      "visible": true
    },
    {
      "name": "interest",
      "default": "0.1",
      "visible": false
    },
    {
      "name": "referenceNumber",
      "visible": true
    },
    {
      "name": "recipientReference",
      "visible": true
    },
    {
      "name": "columns",
      "default": "description,quantity,unit,total,unitPrice,vatPct",
      "visible": true
    },
    {
      "name": "discountEnabled",
      "default": "false",
      "visible": true
    },
    {
      "name": "discountLocation",
      "default": "perTotal",
      "visible": true
    },
    {
      "name": "discountType",
      "default": "amount",
      "visible": true
    },
    {
      "name": "discountVAT",
      "default": "postVAT",
      "visible": true
    },
    {
      "name": "description",
      "default": "",
      "visible": true
    },
    {
      "name": "footerText",
      "default": "",
      "visible": true
    },
    {
      "name": "legalterms",
      "default": "",
      "visible": false
    },
    {
      "name": "dueDate",
      "visible": true
    },
    {
      "default": "default",
      "name": "template",
      "visible": false
    }
  ]
};

const paymentMethodSchema = {
  "other": {
    "name": {
      "hidden": false,
      "mandatory": false,
      "name": "name",
      "label": "name",
      "type": "text",
      "hasDefault": false
    },
    "fields": [
      {
        "hidden": false,
        "mandatory": false,
        "name": "free",
        "label": "free",
        "type": "textarea",
        "hasDefault": false
      }
    ],
    "type": "OTHER",
    "enabled": true
  },
  "paypal": {
    "name": {
      "hidden": false,
      "mandatory": false,
      "name": "name",
      "label": "name",
      "type": "text",
      "hasDefault": false
    },
    "fields": [
      {
        "hidden": false,
        "mandatory": false,
        "name": "paypal",
        "label": "Email",
        "type": "text",
        "hasDefault": false
      }
    ],
    "type": "PAYPAL",
    "enabled": true
  },
  "swish": {
    "name": {
      "hidden": false,
      "mandatory": false,
      "name": "name",
      "label": "name",
      "type": "text",
      "hasDefault": false
    },
    "fields": [
      {
        "hidden": false,
        "mandatory": false,
        "name": "swish",
        "label": "settings.paymentMethod.SWISH",
        "type": "text",
        "hasDefault": false
      }
    ],
    "type": "SWISH",
    "enabled": false
  },
  "plusgiro": {
    "name": {
      "hidden": false,
      "mandatory": false,
      "name": "name",
      "label": "name",
      "type": "text",
      "hasDefault": false
    },
    "fields": [
      {
        "hidden": false,
        "mandatory": false,
        "name": "plusgiro",
        "label": "settings.paymentMethod.PLUSGIRO",
        "type": "text",
        "hasDefault": false
      }
    ],
    "type": "PLUSGIRO",
    "enabled": false
  },
  "bankgiro": {
    "name": {
      "hidden": false,
      "mandatory": false,
      "name": "name",
      "label": "name",
      "type": "text",
      "hasDefault": false
    },
    "fields": [
      {
        "hidden": false,
        "mandatory": false,
        "name": "bankgiro",
        "label": "settings.paymentMethod.BANKGIRO",
        "type": "text",
        "hasDefault": false
      }
    ],
    "type": "BANKGIRO",
    "enabled": false
  },
  "iban": {
    "name": {
      "hidden": false,
      "mandatory": false,
      "name": "name",
      "label": "name",
      "type": "text",
      "hasDefault": false
    },
    "fields": [
      {
        "properties": {
          "placeholder": "input.placeholder.IBAN"
        },
        "hidden": false,
        "mandatory": false,
        "name": "iban",
        "label": "iban",
        "type": "text",
        "hasDefault": false
      },
      {
        "hidden": false,
        "mandatory": false,
        "name": "swift",
        "label": "swift",
        "type": "text",
        "hasDefault": false
      },
      {
        "hidden": false,
        "mandatory": false,
        "name": "bank",
        "label": "bank",
        "type": "text",
        "hasDefault": false
      }
    ],
    "type": "IBAN",
    "enabled": true
  },
  "bban": {
    "name": {
      "hidden": false,
      "mandatory": false,
      "name": "name",
      "label": "name",
      "type": "text",
      "hasDefault": false
    },
    "fields": [
      {
        "type": "text",
        "name": "accountOwner",
        "mandatory": false,
        "label": "accountOwner",
        "hidden": false,
        "hasDefault": false
      },
      {
        "hidden": false,
        "mandatory": false,
        "name": "account",
        "label": "account",
        "type": "text",
        "hasDefault": false
      },
      {
        "hidden": false,
        "mandatory": false,
        "name": "bankNumber",
        "label": "bankNumber",
        "type": "text",
        "hasDefault": false
      },
      {
        "hidden": false,
        "mandatory": false,
        "name": "bank",
        "label": "bank",
        "type": "text",
        "hasDefault": false
      }
    ],
    "type": "BBAN",
    "enabled": false
  }
};

const invoiceSchema = {
  "fields": [
    {
      "hidden": false,
      "mandatory": true,
      "preset": "invoicingProfile",
      "name": "sender",
      "label": "invoice.InvoicingProfile",
      "type": "select",
      "hasDefault": true
    },
    {
      "preset": "language",
      "hidden": false,
      "mandatory": true,
      "name": "language",
      "label": "InvoiceLanguage",
      "type": "select",
      "hasDefault": true
    },
    {
      "preset": "invoicingCurrency",
      "hidden": false,
      "mandatory": true,
      "name": "currency",
      "label": "Currency",
      "type": "select",
      "hasDefault": true
    },
    {
      "hidden": false,
      "mandatory": true,
      "name": "title",
      "label": "invoice.Title",
      "type": "text",
      "hasDefault": true
    },
    {
      "preset": "invoicingType",
      "hidden": false,
      "mandatory": true,
      "name": "type",
      "label": "invoice.Type",
      "type": "select",
      "hasDefault": true
    },
    {
      "preset": "invoiceTemplate",
      "hidden": true,
      "mandatory": true,
      "name": "template",
      "label": "invoice.Template",
      "type": "select",
      "hasDefault": true
    },
    {
      "hidden": false,
      "mandatory": false,
      "name": "paymentTime",
      "label": "PaymentTerms",
      "type": "select",
      "hasDefault": true,
      "preset": "PAYMENT_TERMS"
    },
    {
      "hidden": false,
      "mandatory": false,
      "name": "interest",
      "label": "InterestRate",
      "type": "text",
      "hasDefault": true,
      "preset": "PAYMENT_INTEREST"
    },
    {
      "hidden": false,
      "mandatory": false,
      "name": "referenceNumber",
      "label": "Import.refNo",
      "type": "reference",
      "hasDefault": false
    },
    {
      "hidden": true,
      "mandatory": false,
      "name": "senderReference",
      "label": "invoice.ourReference",
      "type": "text",
      "hasDefault": false
    },
    {
      "properties": {
        "maxlength": "60"
      },
      "hidden": false,
      "mandatory": false,
      "name": "recipientReference",
      "label": "invoice.YourReference",
      "type": "text",
      "hasDefault": false
    },
    {
      "hidden": false,
      "mandatory": true,
      "name": "issueDate",
      "label": "invoice.Date",
      "type": "date",
      "hasDefault": false
    },
    {
      "properties": {
        "min": 1
      },
      "hidden": false,
      "mandatory": true,
      "name": "invoiceNumber",
      "label": "invoice.Number",
      "type": "integer",
      "hasDefault": false
    },
    {
      "preset": "invoicingColumns",
      "hidden": false,
      "mandatory": true,
      "name": "columns",
      "label": "invoice.Fields",
      "type": "select",
      "hasDefault": true
    },
    {
      "hidden": false,
      "mandatory": true,
      "name": "discount",
      "label": "invoice.discountSettings",
      "type": "select",
      "hasDefault": true
    },
    {
      "hidden": false,
      "mandatory": true,
      "name": "dueDate",
      "label": "invoice.dueDate",
      "type": "date",
      "hasDefault": false
    },
    {
      "hidden": true,
      "mandatory": true,
      "name": "discountEnabled",
      "type": "boolean",
      "hasDefault": true
    },
    {
      "hidden": true,
      "mandatory": true,
      "name": "discountLocation",
      "type": "text",
      "hasDefault": true
    },
    {
      "hidden": true,
      "mandatory": true,
      "name": "discountType",
      "type": "text",
      "hasDefault": true
    },
    {
      "hidden": true,
      "mandatory": true,
      "name": "discountVAT",
      "type": "text",
      "hasDefault": true
    },
    {
      "properties": {
        "maxlength": "3000"
      },
      "hidden": false,
      "mandatory": true,
      "name": "description",
      "label": "invoice.Description",
      "type": "area",
      "hasDefault": true
    },
    {
      "hidden": false,
      "mandatory": true,
      "name": "customer",
      "type": "select",
      "hasDefault": false
    },
    {
      "properties": {
        "maxlength": "250"
      },
      "hidden": false,
      "mandatory": true,
      "name": "footerText",
      "label": "invoice.ExtraText",
      "type": "area",
      "hasDefault": true
    },
    {
      "properties": {
        "placeholder": "invoice.legalterms.placeholder"
      },
      "hidden": false,
      "mandatory": false,
      "name": "legalterms",
      "label": "it_legal_terms",
      "type": "area",
      "hasDefault": true
    }
  ]
};

export const settingsStub: SettingsInterface = {
  isOneProductUser: false,
  values: {
    paymentMethods: [],
    regional: {
      longTime: 'h:i',
      longDate: 'd.M.y'
    },
    // @ts-ignore
    company: {
      tradeNames: [
        {
          default: true,
          logo: {
            id: '123',
            content: 'foo',
            name: 'bar'
          },
          name: 'tradename',
          address: {},
          contact: {
            name: {
              first: 'First',
              last: 'Last',
              full: 'First Last'
            }
          }
        }
      ],
      vat: 0.2,
      legalStatus: 'foo',
      rcs: '1'
    }
  },
  managedFields: {
    PAYMENT_INTEREST: [],
    PAYMENT_TERMS: [0, 5, 7, 14, 30, 33, 60, 90],
    UNITS: [],
    VAT: []
  },
  models: [
    invoiceModel
  ],
  modules: [
    {
      roles: [
        'COMPANYADMIN',
        'ADMIN',
        'USER'
      ],
      module: 'settings',
      menu: true,
      label: 'Account',
      name: 'settings',
      hidden: false,
      views: [
        {
          roles: [
            'COMPANYADMIN',
            'ADMIN'
          ],
          view: 'reactSubscription',
          menu: true,
          name: 'reactSubscription',
          hidden: false,
          label: 'oneSubscription'
        }
      ]
    }, {
      hidden: false,
      name: 'work',
      label: 'time.tracker',
      menu: true,
      module: 'work',
      roles: [
        'COMPANYADMIN',
        'ADMIN',
        'USER'
      ]
    }
  ],
  schemas: {
    // @ts-ignore
    invoice: invoiceSchema,
    paymentMethod: paymentMethodSchema,
    estimate: {
      fields: []
    },
    receipt: {
      fields: []
    }
  },
  styles: {}
};
